var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTickCircle = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 48 48"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "var(--thc-icon-fill)",
  fillRule: "evenodd",
  d: "M24 4C12.97 4 4 12.97 4 24s8.97 20 20 20 20-8.97 20-20S35.03 4 24 4",
  clipRule: "evenodd",
  "data-filled": "true"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--thc-icon-fill)",
  fillRule: "evenodd",
  d: "M24 4C12.97 4 4 12.97 4 24s8.97 20 20 20 20-8.97 20-20S35.03 4 24 4m0 37.4c-9.59 0-17.4-7.81-17.4-17.4S14.41 6.6 24 6.6 41.4 14.41 41.4 24 33.59 41.4 24 41.4",
  clipRule: "evenodd",
  "data-filled": "false"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--thc-icon-accent-fill, var(--thc-icon-accent-fill-default, white))",
  fillRule: "evenodd",
  d: "M30.97 16.98 21.22 29.7l-4.43-3.36a1.3 1.3 0 0 0-1.82.25 1.3 1.3 0 0 0 .25 1.82l5.46 4.14a1.3 1.3 0 0 0 1.81-.25l10.54-13.74a1.3 1.3 0 0 0-.24-1.82 1.3 1.3 0 0 0-1.82.24v.01Z",
  clipRule: "evenodd"
})));
export { SvgTickCircle as ReactComponent };
export default new URL("/home/runner/work/motorway-seller-webapp/motorway-seller-webapp/node_modules/@motorway/mw-highway-code/src/assets/svgs/tick-circle.svg", import.meta.url).toString();